import {
  ConfigClientEnum,
  IMemberVenueId,
} from "@interfaces/enums/apiData.enum";

export default {
  config: "/config.json",
  galleryConfig: "gallery/config",
  activeTheme: (client: ConfigClientEnum): string =>
    `/gallery/themes/active?venueId=${IMemberVenueId[client]}`,
  guestInfo: "/gallery/guest",
  saveGuest: "/gallery/guest",
  saveGuestWithVisit: (isGuestbookAnimation?: boolean): string =>
    isGuestbookAnimation
      ? "/gallery/guest-with-visit?isGuestbookAnimation=true"
      : "/gallery/guest-with-visit",
  mediaShare: "/gallery/share",
  mediaCompose: (mediaId: string): string => `/media/${mediaId}/compose`,
  getMediaById: (mediaId: string): string => `/gallery/media/${mediaId}`,
  helpRequest: "/gallery/help-center",
  getMedia: "gallery/media",
  mediaDownload: "/gallery/download",
  experienceDevice: (deviceUuid: string): string =>
    `/experience/device/${deviceUuid}`,
  visitFormSubmit: (isGuestbookAnimation?: boolean): string =>
    isGuestbookAnimation
      ? `/visit/form?isGuestbookAnimation=true`
      : "/visit/form",
  visitAnimationTrigger: "/visit/animation-trigger",
  mediaAdjust: (mediaId: string): string => `/media/${mediaId}/adjust`,
};
